import { IoCodeWorking } from "react-icons/io5";

export const Experience = [
    
    {
        id: 1,
        date: "2023 - present",
        iconsSrc: <IoCodeWorking/>,
        title: "MCA in Artificial Intelligence & Machine Learning",
        location: "Mohali, Punjab",
        description: "I am currently pursuing my MCA from Chandigarh University with a CGPA of 8.41, focusing on advanced concepts in computer science, artificial intelligence, and machine learning, demonstrating my dedication to mastering these dynamic fields.",
    },
    {
        id: 2,
        date: "2020 - 2023",
        iconsSrc: <IoCodeWorking/>,
        title: "Bachelors of Science",
        location: "Ludhiana, Punjab",
        description: "I completed my Bachelor's degree in Science at S.C.D Govt. College, Ludhiana, with a score of 75.9%, reflecting my commitment to academic excellence and my foundation in scientific principles.",
    },
    {
        id: 3,
        date: "2019-2020",
        iconsSrc: <IoCodeWorking/>,
        title: "12th",
        location: "Ludhiana, Punjab",
        description: "I completed my 12th grade at International Public School, Ludhiana, affiliated with the CBSE Board, with a score of 87.2%, showcasing my dedication and strong academic foundation for my future studies",
    },
    {
        id: 4,
        date: "2017-2018",
        iconsSrc: <IoCodeWorking/>,
        title: "10th",
        location: "Ludhiana, Punjab",
        description: "I completed my 10th standard at International Public School, Ludhiana, affiliated with the CBSE Board, achieving a score of 91.7%, which laid a strong foundation for my academic pursuits.",
    },
    
]